export default __webpack_public_path__ + "static/media/lecteuromniscient.2cfffb7e.jpg";